import type { RouteProps } from 'react-router-dom';
import { Redirect, Route } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { paths } from 'modules/router';
import { sessionSelectors } from 'modules/session/selectors';

const RouteWithAuth = ({ children, ...rest }: RouteProps & { children?: React.ReactNode }) => {
  const isLoggedIn = useSelector(sessionSelectors.isLoggedIn);

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (isLoggedIn) {
          return children;
        }
        // if (
        //   location.pathname === '/' &&
        //   process.env.REACT_APP_ENV === 'production' &&
        //   process.env.REACT_APP_LANDING_URL
        // ) {
        //   window.location.href = process.env.REACT_APP_LANDING_URL;
        //   return <></>;
        // }
        return (
          <Redirect
            to={{
              pathname: paths.signIn,
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default RouteWithAuth;
